import type { RelativeAbsolutePosition } from '../../core/types/pointer-events.js';
import { UndefinedContent, type XYChartState } from '../types/state.js';

export function reduceResetInteractions(
  {
    position,
    zoomStatus,
  }: {
    position?: RelativeAbsolutePosition;
    zoomStatus?: Partial<XYChartState['zoom']>;
  } = { zoomStatus: {} },
) {
  return (prev: XYChartState): XYChartState => ({
    ...prev,
    interactionMode: 'explore',
    highlightedSeriesIds: undefined,
    explore: {
      ...prev.explore,
      position: position,
      pinned: false,
      content: UndefinedContent,
    },
    select: undefined,
    currentDomain: undefined,
    zoom: {
      zoomInEnabled: true,
      zoomOutEnabled: false,
      ...zoomStatus,
    },
  });
}
